// ---------------------------------------------------------------------------
// A Hive as the difference from another: what a reveal carries per clash
// ---------------------------------------------------------------------------
//
// A reveal plays a round back clash by clash, each with the struck Hive as
// it stood after its crater (and after each shot of it). Sent whole, that is
// a 315-cell Hive per snapshot; a round's craters change only a few cells.
// So each snapshot travels as the difference from the round's starting Hive:
// the cells that differ (whole), and the maps (structures, Broods, intel
// letters) whole, since they are small. applyHiveDelta rebuilds it.

const cellKey = (c) => JSON.stringify(c)

export function hiveDelta(base, hf) {
    if (!hf) return null
    const cells = {}
    hf.subplots.forEach((c, s) => {
        if (!base?.subplots?.[s] || cellKey(base.subplots[s]) !== cellKey(c)) cells[s] = c
    })
    const out = { cells, structures: hf.structures ?? {}, broods: hf.broods ?? {} }
    if (hf.intelLetters) out.intelLetters = hf.intelLetters
    return out
}

export function applyHiveDelta(base, delta) {
    if (!delta) return null
    const subplots = base.subplots.map((c, s) => (delta.cells[s] ? { ...delta.cells[s] } : { ...c }))
    const out = { subplots, structures: JSON.parse(JSON.stringify(delta.structures)), broods: JSON.parse(JSON.stringify(delta.broods)) }
    if (delta.intelLetters) out.intelLetters = { ...delta.intelLetters }
    return out
}
